export enum IArrowPaginationButton {
  BEFORE = "<",
  AFTER = ">",
}
